
    import { ModalBeforeOpenEvent } from '@/models/Interfaces';
    import {
        SMSProfileRowResource,
        SMSsHistoryFilter,
        SMSsProfilesFilter,
        EmailSMSTemplateRowResource,
        SmsTemplateFilter,
    } from '@/models/SMS';
    import _ from 'lodash';
    import Swal from 'sweetalert2';
    import { api } from '@/services/Api';
    import { Options, Vue } from 'vue-class-component';
    import Q from 'q';
    import { mapGetters, mapState } from 'vuex';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper';
    import { onMounted, ref, computed, defineComponent, inject } from 'vue';
    import { generalStore, useStore } from '@/store';
    import { useI18n } from 'vue-i18n';
    import { Newsletter, NewslettersFilter } from '@/models/Newsletter';
    import router from '@/router';

    export type OnSaveCallback = (filter: SMSsHistoryFilter) => void;

    export default defineComponent({
        name: 'NewsletterTab',
        components: {
            Swiper,
            SwiperSlide,
            Pagination,
        },
        props: {
            name: String,
            isEmail: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { emit }) {
            const { t } = useI18n();
            const store = useStore();
            const GetEmailPreview = computed(() => store.getters['GetEmailPreview']);
            const loaded = ref(false);
            const filter = ref('');
            const appliedFilter = ref('');
            const rows = ref<EmailSMSTemplateRowResource[]>([]);
            const selectedRow = ref<EmailSMSTemplateRowResource | null>(null);
            const onSave = ref<OnSaveCallback | null>(null);
            const requestFilter = ref<NewslettersFilter>(new NewslettersFilter());
            const pagination = { clickable: false };
            const mySwiper = ref<any | null>(null);
            const modules = [Navigation, Pagination, Mousewheel, Keyboard];
            const onSwiper = (swiper: any) => (mySwiper.value = swiper);
            let countOfLinksOnPage = 12;
            const slideEmails = computed(() => _.chunk(rows.value, countOfLinksOnPage));
            const selectPage = (row: Newsletter) => router.push({ name: 'newsletter-template', params: { id: row.Id } });

            async function beforeOpen(event: ModalBeforeOpenEvent) {
                rows.value = [];
                loaded.value = false;
                var delay = Q.delay(1000);
                selectedRow.value = null;
                requestFilter.value = {
                    IsTextTemplate: true,
                    Keywords: null,
                    OrderBy: null,
                };
                onSave.value = event.params?.onSave || null;
                await onSearch();
                await delay;
                loaded.value = true;
            }
            const filteredRows = computed(() => {
                if (appliedFilter.value == '') {
                    return rows.value;
                }
                return rows.value.filter((x: EmailSMSTemplateRowResource) => x.Name.includes(appliedFilter.value));
            });

            function idSelector(row: EmailSMSTemplateRowResource) {
                return row.Id;
            }
            async function onSearch(withLoader = false) {
                if (props.isEmail) {
                    if (withLoader) {
                        Swal.showLoading();
                    }
                    rows.value = [];
                    const respPromise = api.GetNewsletters(requestFilter.value);
                    await Q.delay(400);
                    var resp = await respPromise;
                    if (resp.Error || !resp.Data) {
                        Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning');
                        return;
                    }
                    rows.value = resp.Data.Rows.map(
                        (x) =>
                            ({
                                Id: x.Id,
                                Name: x.Name,
                                Message: x.HTML,
                                ChangeBoth: false,
                                CreatedAt: x.CreatedAt,
                                UpdatedAt: x.UpdatedAt,
                                PreviewPath: requestFilter.value.IsTextTemplate ? '' : GetEmailPreview.value(x.Id),
                            } as EmailSMSTemplateRowResource)
                    );
                    if (Swal.isLoading()) {
                        Swal.close();
                    }
                } else {
                    var respPromise = api.SMSGetTemplatesForSelect();
                    var resp2 = await respPromise;
                    if (resp2.Error || !resp2.Data) {
                        Swal.fire(resp2.ErrorMessage || 'Oops..', '', 'warning');
                        return;
                    }
                    rows.value = resp2.Data;
                }
            }
            async function onFilter() {
                loaded.value = false;
                await Q.delay(1000);
                appliedFilter.value = filter.value;
                loaded.value = true;
            }
            function selectTemplate(row: EmailSMSTemplateRowResource) {
                if (selectedRow.value && selectedRow.value.Id === row.Id) {
                    selectedRow.value = null;
                } else {
                    selectedRow.value = row;
                }
            }
            function saveSelectedTemplate() {
                if (!selectedRow.value) {
                    Swal.fire({
                        icon: 'error',
                        text: t('page.automation.filter.selectSmsTemplate') as string,
                    });
                    return;
                }

                if (props.isEmail && !requestFilter.value.IsTextTemplate) {
                    emit('setDesignedTemplate', selectedRow.value);
                } else {
                    emit('templateSelected', selectedRow.value);
                }
            }

            function changeType(type: boolean) {
                selectedRow.value = null;
                requestFilter.value.IsTextTemplate = type;
            }
            return {
                beforeOpen,
                GetEmailPreview,
                requestFilter,
                changeType,
                onSearch,
                onFilter,
                filter,
                loaded,
                filteredRows,
                selectTemplate,
                selectedRow,
                saveSelectedTemplate,
                pagination,
                modules,
                onSwiper,
                slideEmails,
                selectPage,
                mySwiper,
            };
        },
    });
